


















































import Vue from 'vue';

import Task from '@/models/soukai/Task';

import DatePickerInput from '@/components/DatePickerInput.vue';

import AsyncOperation from '@/utils/AsyncOperation';
import EventBus from '@/utils/EventBus';

interface Data {
    name: string,
    description: string,
    dueAt: Date | null,
}

export default Vue.extend({
    components: {
        DatePickerInput,
    },
    props: {
        task: {
            type: Object as () => Task,
            required: true,
        },
    },
    data(): Data {
        return {
            name: '',
            description: '',
            dueAt: null,
        };
    },
    computed: {
        focusEventListener(): Function {
            return (field: string) => (this.$refs[field] as any).focus();
        },
    },
    watch: {
        task() {
            this.updateValues();
        },
    },
    created() {
        this.updateValues();
        EventBus.on('focus', this.focusEventListener);
    },
    destroyed() {
        EventBus.off('focus', this.focusEventListener);
    },
    methods: {
        async save() {
            this.$tasks.setEditing(false);

            await this.$ui.updateModel(
                this.task,
                task => task.update({
                    name: this.name,
                    description: this.description || undefined,
                    dueAt: this.dueAt || undefined,
                }),
                ['name', 'description', 'dueAt'],
            );
        },
        cancel() {
            this.$tasks.setEditing(false);
        },
        updateValues() {
            this.name = this.task.name;
            this.description = this.task.description;
            this.dueAt = this.task.dueAt;
        },
    },
});
